import axios from "../lib/axios";

export const createCategory = async (data) => {
  try {
    const response = await axios.post("/category/add", data);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create category"
    );
  }
};

export const getAllCategories = async () => {
  try {
    const response = await axios.get("/category/all");
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch categories"
    );
  }
};
